import { render, staticRenderFns } from "./OfficeStepper.vue?vue&type=template&id=23065e70&scoped=true&"
import script from "./OfficeStepper.vue?vue&type=script&lang=js&"
export * from "./OfficeStepper.vue?vue&type=script&lang=js&"
import style0 from "./OfficeStepper.vue?vue&type=style&index=0&id=23065e70&prod&scoped=true&lang=css&"
import style1 from "./OfficeStepper.vue?vue&type=style&index=1&id=23065e70&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23065e70",
  null
  
)

export default component.exports